// extracted by mini-css-extract-plugin
export default {"aboutus":"AboutPostsList_aboutus__CLHjl"};